import React from "react";
import "../Styles/Faq.css";
const FAQs = () => {
  return (
    <div className="faq-cover">
      <div className="faq-main">
        <h1
          data-aos="zoom"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
        >
          FAQs on Outsourcing Healthcare BPO to India
        </h1>
        <p
          data-aos="zoom"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
        >
          Are you looking to outsource healthcare BPO and have no clue how to go
          about it? Here are some of the frequently asked questions by our
          customers while outsourcing their healthcare BPO services to us –
        </p>
        <ol>
          <li>
            <h2>
              I want to outsource healthcare BPO to Clinics4Health. How do I
              start?
            </h2>
          </li>
          <p
            data-aos="zoom"
            data-aos-duration="500"
            data-aos-easing="ease-in-out"
          >
            You can either call us or fill in the contact form with your
            requirements and we will get back to you. You can also send your
            files by any of the following methods –
          </p>
          <ul>
            <li>
              <p
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                Access files from a web-based application
              </p>
            </li>
            <li>
              <p
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                Upload files in an FTP server
              </p>
            </li>
            <li>
              <p
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                Remote log in
              </p>
            </li>
            <li>
              <p
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                Send the files as an e-mail attachment
              </p>
            </li>
          </ul>
          <li>
            <h2>
              Can I just outsource just a part of the project or it have to
              outsource entire project at a go?
            </h2>
          </li>
          <p
            data-aos="zoom"
            data-aos-duration="500"
            data-aos-easing="ease-in-out"
          >
            The decision to outsource a part or the entire project is totally
            left to you. We provide customized solutions to each and every
            client.
          </p>
          <li>
            <h2>
              For how long has Clinics4Health been outsourcing Healthcare BPO?
            </h2>
          </li>
          <p
            data-aos="zoom"
            data-aos-duration="500"
            data-aos-easing="ease-in-out"
          >
            Clinics4Health has been providing healthcare services for more than
            16 years now.
          </p>
          <li>
            <h2>What type of customers do you serve?</h2>
          </li>
          <p
            data-aos="zoom"
            data-aos-duration="500"
            data-aos-easing="ease-in-out"
          >
            We serve a wide range of customers:
          </p>
          <ul>
            <li>
              <p
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                Hospitals and clinics
              </p>
            </li>
            <li>
              <p
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                Physicians and healthcare consultants
              </p>
            </li>
            <li>
              <p
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                Medical practitioners
              </p>
            </li>
          </ul>
          <li>
            <h2>Do you work on weekends?</h2>
          </li>
          <p
            data-aos="zoom"
            data-aos-duration="500"
            data-aos-easing="ease-in-out"
          >
            We usually are available between 7.30 PM EST (Monday) and 3.30 PM
            EST (Saturday). If the project demands, we are available to work on
            weekends as well.
          </p>
          <li>
            <h2>
              How will you ensure the security of my confidential healthcare
              data?
            </h2>
          </li>
          <p
            data-aos="zoom"
            data-aos-duration="500"
            data-aos-easing="ease-in-out"
          >
            We make sure that no client data is published, sold, or distributed
            to any third-party. Our employees sign a non-disclosure agreement
            while joining and also at the beginning of any new project. Your
            data is completely safe with us.
          </p>
          <li>
            <h2>
              What kind of quality processes are undertaken at Clinics4Health?
            </h2>
          </li>
          <p
            data-aos="zoom"
            data-aos-duration="500"
            data-aos-easing="ease-in-out"
          >
            We follow stringent quality procedures to ensure that we deliver
            high-quality healthcare services. We are RBMA and HIPAA compliant.
          </p>
          <li>
            <h2>Does Clinics4Health provide a free trial?</h2>
          </li>
          <p
            data-aos="zoom"
            data-aos-duration="500"
            data-aos-easing="ease-in-out"
          >
            Yes, we do provide a free trial for a period of 5 days for all our
            healthcare services. You can sign the contract with us after you are
            satisfied with our services.
          </p>
          <li>
            <h2>Do you use any kind of software?</h2>
          </li>
          <p
            data-aos="zoom"
            data-aos-duration="500"
            data-aos-easing="ease-in-out"
          >
            Our team is proficient in using a variety of software like
            E-Clinical Works, Kareo, Advantx, Medical Manager, MEDISOFT, NextGen
            among others.
          </p>
          <li>
            <h2>Can you revisit some of the Explanation of Benefits (EOBs)?</h2>
          </li>
          <p
            data-aos="zoom"
            data-aos-duration="500"
            data-aos-easing="ease-in-out"
          >
            Our cutting edge technology allows us to scan your EOBs into our
            rules-based engine. The digital format of the file helps in
            auto-post payments and EOB details.
          </p>
          <li>
            <h2>Will I be able to obtain eligibility and claim status?</h2>
          </li>
          <p
            data-aos="zoom"
            data-aos-duration="500"
            data-aos-easing="ease-in-out"
          >
            Yes, we do help our customers obtain eligibility and claim status
            from insurance companies.
          </p>
          <li>
            <h2>
              Can my medical billing software program access Clinics4Health's
              Rules-Based Engine?
            </h2>
          </li>
          <p
            data-aos="zoom"
            data-aos-duration="500"
            data-aos-easing="ease-in-out"
          >
            Yes. The way claims and EOBs are sent has been standardized by
            HIPAA. Hence, our customers can easily access our artificial
            intelligence.
          </p>
          <li>
            <h2>How easy to use is the Internet Message Center?</h2>
          </li>
          <p
            data-aos="zoom"
            data-aos-duration="500"
            data-aos-easing="ease-in-out"
          >
            Internet Message Center is based on customer surveys and the
            information is straight forward, which makes using the Internet
            Message Center very easy.
          </p>
          <li>
            <h2>Is Clinics4Health’s information database updated?</h2>
          </li>
          <p
            data-aos="zoom"
            data-aos-duration="500"
            data-aos-easing="ease-in-out"
          >
            Yes. Our information database is dynamic. In case of any changes,
            the rules-based engine alerts the processing unit and avoids errors.
            The rules-based engine consists of:
          </p>
          <ul>
            <li>
              <p
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                HIPAA security rules and guidelines
              </p>
            </li>
            <li>
              <p
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                Medical review policy guidelines
              </p>
            </li>
            <li>
              <p
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                HCFA compulsory fields
              </p>
            </li>
            <li>
              <p
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                Matching CPT and diagnosis codes
              </p>
            </li>
            <li>
              <p
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                Payer-specific application of rules
              </p>
            </li>
          </ul>
          <li>
            <h2>
              What according to you are the key factors which determine a
              project’s success?
            </h2>
          </li>
          <ol>
            <li>
              <h3>Communication</h3>
            </li>
            <p
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              A project is inclusive of client expectations, timelines,
              operational instructions, metrics, and several other factors.
              Collaboration, communication, and documentation are pith and core
              of a project lifecycle. Therefore, communication is kept taut
              between our project team and clients to achieve a successful
              outcome. Assumptions have no place in our project workflow because
              it can lead to misinterpretation of requirements, unwarranted
              delays, and complications in deliverables. We also document
              clarifications, queries, and extra information exchanged between
              stakeholders to ensure clarity.
            </p>
            <li>
              <h3>Transparency</h3>
            </li>
            <p
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              We ensure transparency throughout the project by detecting and
              resolving problems before it’s too late to attempt a simple fix.
              We commit ourselves to make the project execution simpler for
              seamless backtracking.
            </p>
            <li>
              <h3>Transition</h3>
            </li>
            <p
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              We never overlook the transition phase of the project because
              simple missteps can cause a daisy-chain effect, affecting other
              areas of the project. Therefore, we take special care to
              completely suppress the minor problems that can come back to haunt
              in the post-transition phase.
            </p>
            <li>
              <h3>Supervision by Senior Management</h3>
            </li>
            <p
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              When project members work under tight deadlines, it is possible
              for a minor flaw or glitch to go unnoticed. This is because the
              staff handling the transition and everyday interactions can view
              those tasks as a mere extension of their routines. However, under
              the supervision of a senior management executive, potential risks
              can be reversed in its track before it becomes a complication.
            </p>
            <li>
              <h3>SPOC</h3>
            </li>
            <p
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              Our project management team is incomplete without a single point
              of contact. Our SPOC will liaise with the project team to ensure
              there are no pending approvals and requests for resources. They
              play a critical role in meeting the requirements of the project
              members during the project. They hold the authority and access to
              key resources to avoid delays on deliverable outcomes.
            </p>
          </ol>
          <li>
            <h2>What is the project turnaround time?</h2>
          </li>
          <p
            data-aos="zoom"
            data-aos-duration="500"
            data-aos-easing="ease-in-out"
          >
            We provide a guaranteed turnaround time of 24 hours. But, the
            project completion time may vary depending on the project
            complexity, size, and the services offered.
          </p>
          <li>
            <h2>What is the pricing model of your healthcare services?</h2>
          </li>
          <p
            data-aos="zoom"
            data-aos-duration="500"
            data-aos-easing="ease-in-out"
          >
            We provide very competitive prices for our healthcare BPO services.
            The quote may depend on the type of the project, technology used,
            and the project complexity.
          </p>
          <p
            data-aos="zoom"
            data-aos-duration="500"
            data-aos-easing="ease-in-out"
          >
            Read more about our pricing structure.
          </p>
          <li>
            <h2>How can I make the payment?</h2>
          </li>
          <p
            data-aos="zoom"
            data-aos-duration="500"
            data-aos-easing="ease-in-out"
          >
            We accept payments through credit card, wire transfer, PayPal, and
            checks (within INDIA).
          </p>
          <li>
            <h2>
              Why should I choose Clincs4Health Solutions to outsource
              healthcare BPO services?
            </h2>
          </li>
          <p
            data-aos="zoom"
            data-aos-duration="500"
            data-aos-easing="ease-in-out"
          >
            Partnering with Clincs4Health Solutions comes with a range of
            benefits:
          </p>
          <ul>
            <li>
              <p
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                No administrative and infrastructural hassles
              </p>
            </li>
            <li>
              <p
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                Competitive prices within a quick turnaround time
              </p>
            </li>
            <li>
              <p
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                Availability of skilled resources and healthcare professionals
              </p>
            </li>
            <li>
              <p
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                Streamlined business transformation and revenue generation
              </p>
            </li>
            <li>
              <p
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                Increased efficiency and productivity
              </p>
            </li>
          </ul>
        </ol>
        <p
          data-aos="zoom"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
        >
          Hope these answers were able to clear most of your doubts. If any of
          your questions are still unanswered or not satisfactorily answered,
          feel free to get in touch with us.
        </p>
      </div>
    </div>
  );
};

export default FAQs;
